import React from "react";

// Lightweight modal shell reused by the organiser rehost pages.
// Styling is driven by the .rehost-modal-* CSS classes defined
// in the RehostEventDetails.css file.

const RehostModal = ({
  title,
  children,
  onClose,
  showCloseButton = false,
  closeLabel = "Close",
}) => {
  return (
    <div className="rehost-modal-backdrop">
      <div className="rehost-modal">
        {title && <h3 className="rehost-modal-title">{title}</h3>}
        <div className="rehost-modal-body">{children}</div>
        {showCloseButton && (
          <div className="rehost-modal-actions">
            <button type="button" className="submit-btn" onClick={onClose}>
              {closeLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RehostModal;
